module.exports = __webpack_public_path__ + "static/media/guru-prasadam.dd41d2c7.png";